/* src/app/pages/project/map/repository/import-wizard/import-wizard.component.scss */
.import-wizard-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 1200px;
  height: 90vh;
  background: var(--popover);
  color: var(--popover-foreground);
  border-radius: var(--radius-md);
  padding: 0;
  box-shadow:
    0 0 0 1px color-mix(in srgb, var(--foreground) 10%, transparent),
    0 20px 25px -5px color-mix(in srgb, black 20%, transparent),
    0 8px 10px -6px color-mix(in srgb, black 20%, transparent);
  border: none;
  outline: none;
  overflow: hidden;
}
.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: var(--secondary-foreground);
  background-color: var(--secondary);
  border: none;
  border-radius: var(--radius-button);
  cursor: pointer;
  transition: background-color 150ms ease-in-out;
}
.close-button:hover {
  background-color: color-mix(in srgb, var(--foreground) 12%, var(--secondary));
}
.close-button:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
}
.close-button svg {
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=import-wizard.component-5GUU6VT5.css.map */
